import React from 'react';

function DeleteButton({
  selectedItems
}) {
  return (
    <div className={`${selectedItems.length < 1 && 'hidden'}`}>
      <div className="flex items-center">
        <div className="hidden xl:block text-sm italic mr-2 whitespace-nowrap"><span>{selectedItems.length}</span> registros seleccionados</div>
        <button className="btn bg-white border-gray-200 hover:border-gray-300 text-red-500 hover:text-red-600">Borrar</button>
      </div>
    </div>
  );
}

export default DeleteButton;